var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaperPlane(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#000",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    stroke: "#9E9E9E",
    strokeWidth: 2,
    d: "M62.428 22.545a1.918 1.918 0 00-1.903-.461L19.357 33.427a3.377 3.377 0 00-2.302 2.598c-.223 1.233.24 2.432 1.242 3.21.75.583 1.85 1.433 3.073 2.378 1.864 1.444 4.007 3.1 5.636 4.372v8.571c0 .024 0 .047.002.07.081 1.133 1.058 2.018 2.22 2.018a2.24 2.24 0 001.423-.511l4.956-3.342c2.312 1.841 4.406 3.517 5.506 4.398l.064.053a3.48 3.48 0 002.166.758 3.45 3.45 0 002.833-1.463 1.23 1.23 0 00.066-.11l16.485-31.594a1.805 1.805 0 00.032-1.856 1.927 1.927 0 00-.332-.432zM19.523 37.458a1.303 1.303 0 01-.5-1.283c.089-.494.436-.883.885-1.027L57 25 28.03 44a2185.752 2185.752 0 00-5.44-4.184c-1.219-.938-2.317-1.78-3.067-2.358zm9.88 17.414a1.417 1.417 0 00-.109.081.169.169 0 01-.112.047c-.002 0-.157-.002-.182-.14V48l5 3.865-4.597 3.007zm15.15.604c-.446.583-1.377.705-1.964.237l-.063-.052C40.286 53.877 33.88 48.777 30 45.74L60 26 44.553 55.476z"
  }))));
}

export default SvgPaperPlane;